import { pixelRatio2d } from '@/editor/math/const';
import { globalStores } from '@/editor/stores';
import BaseModel2d from './BaseModel2d';
import { GridHelper } from 'three';
import { ENTITY_LATER } from '@/editor/constant/entity';

class GroundModel extends BaseModel2d {
  constructor() {
    super();

    globalStores.editorStateStore.sceneInfo.scene2d.intersectableGroup.add(this._modelGroup);
  }

  createModel() {
    this.clear();

    // 添加网格辅助
    // 正负2000大小的网格，单行共pixelRatio2d*4格
    const gridHelper = new GridHelper(2000, pixelRatio2d * 4, 0xe6e7e9, 0xe6e7e9);
    gridHelper.rotation.x = Math.PI / 2; // 旋转到XY平面
    gridHelper.layers.set(ENTITY_LATER.HELPER_LAYER);
    gridHelper.material.depthTest = true;
    gridHelper.material.depthWrite = false; // 不写入深度缓冲区，其他物体可以遮挡地面网格
    this._modelGroup.add(gridHelper);
  }
}

export default GroundModel;
